import request from '../httpClient';
// tslint:disable
export const getPromoteListings = (
  userId: number,
  limit: number,
  offset: number
) => {
  const params = {
    userId,
    _limit: limit,
    _offset: offset
  };
  return request.get('/promote_listings', params);
};

export const deletePromoteListing = (listingId: number) =>
  request.delete(`/promote_listings/${listingId}`);

export const updatePromoteListing = (listingId: number, data: any) =>
  request.put(`/promote_listings/${listingId}`, data);

export const getPromoteListing = (listingId: number) =>
  request.get(`/promote_listings/${listingId}`);

export const createPromoteListing = (data: any) =>
  request.post('/promote_listings', data);



// WEBPACK FOOTER //
// ./src/services/api/promoteListingApi.ts